import { UserSubscribeState } from '@src/atom/user/userSubscribe';
import { MembershipCode } from '@src/constants';
import { UserSession } from '@src/lib/user/UserSession';
import ThemeImg from '@src/view/common/ThemeImg';
import cn from 'clsx';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
import { useRecoilValue } from 'recoil';

export const enum LogoImgPath {
  DEFAULT = '/images/common/logo/toptoon/light/logo-toptoon-light.png', // 기본 로고
  MEMBERSHIP_PREMIUM = '/images/common/logo/toptoon/logo_toptoon_premium.png',
  // SECOND = '/images/common/logo/logo_blackfriday.png', // 미사용
  // MEMBERSHIP_BASIC = '/images/common/logo/logo_basic_dk.png', // 미사용
  // MEMBERSHIP_STANDARD = '/images/common/logo/logo_standard.png', // 미사용
  // EVENT = '/images/common/logo/logo_0214.png', // 이벤트 용 로고
}

export const enum DarkLogoImgPath {
  DEFAULT = '/images/common/logo/toptoon/dark/logo-toptoon-dark.png', // 기본 로고(다크)
  MEMBERSHIP_PREMIUM = '/images/common/logo/toptoon/logo_toptoon_premium.png',
}

export interface LogoType {
  path: string;
}

const Logo = () => {
  const userSubscribe = useRecoilValue(UserSubscribeState);

  const logoPath = useMemo(() => {
    const { userSubscribe: cookieUserSubscribe } = UserSession.getCoinInfo();

    const isMembershipUser =
      (userSubscribe && userSubscribe.code === MembershipCode.PREMIUM) ||
      (cookieUserSubscribe &&
        cookieUserSubscribe.code === MembershipCode.PREMIUM);

    if (isMembershipUser) {
      return {
        lightImg: LogoImgPath.MEMBERSHIP_PREMIUM,
        darkImg: DarkLogoImgPath.MEMBERSHIP_PREMIUM,
      };
    } else {
      return {
        lightImg: LogoImgPath.DEFAULT,
        darkImg: DarkLogoImgPath.DEFAULT,
      };
    }
  }, [userSubscribe]);

  const isDev =
    process.env.REACT_APP_ENVIRONMENT &&
    !(process.env.REACT_APP_ENVIRONMENT === 'production');

  return (
    //TODO: toptoon
    <div
      id="logoArea"
      className={cn(
        'h-[50px] grid-in-logo self-start relative',
        'middle:w-[130px] mo:w-[90px]',
      )}
    >
      {/* Header Logo 영역 */}
      <a href="/" className={'flex gap-1 items-center h-full relative'}>
        {/* <img src={logoPath} alt="logo" className="" /> */}
        <ThemeImg
          className=""
          lightImg={logoPath.lightImg}
          darkImg={logoPath.darkImg}
          alt={'logo'}
        />
        <h1 className='font-extrabold text-[28px]'>Plus</h1>
        {isDev && (
          <div
            className={cn(
              'absolute text-[0.8rem] bottom-[-15px] left-0 font-[600] py-[1px] px-[3px] text-[#ff6665] whitespace-nowrap',
              'tablet:bottom-[-8px] mo:bottom-[-4px] middle:text-[0.6rem]',
            )}
          >
            {process.env.REACT_APP_ENVIRONMENT?.toUpperCase()} 환경
          </div>
        )}
      </a>
      {/* Header Logo 영역 */}
    </div>
  );
};
export default Logo;
